import React from 'react';
import { IconSvgProps } from '@models/common';

const Delete: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.125 7.55556L17.3661 18.3489C17.3007 19.2792 16.5387 20 15.6205 20H8.37946C7.46134 20 6.69932 19.2792 6.63391 18.3489L5.875 7.55556M10.25 11.1111V16.4444M13.75 11.1111V16.4444M14.625 7.55556V4.88889C14.625 4.39797 14.2332 4 13.75 4H10.25C9.76675 4 9.375 4.39797 9.375 4.88889V7.55556M5 7.55556H19'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Delete;
